const PipelineIconColorEnums = {
   Green: 'GREEN',
   Orange: 'ORANGE',
   Fuchsia: 'FUCHSIA',
   Teal: 'TEAL',
   Violet: 'VIOLET',
   BlueLight: 'BLUE_LIGHT'
}

export const PipelineIconEnums = {
   InterSectCircle: 'INTERSECT_CIRCLE',
   LayersTwo: 'LAYERS_TWO',
   Rocket2: 'ROCKET2',
   CodePen: 'CODE_PEN',
   Rocket1: 'ROCKET1',
   PuzzlePiece: 'PUZZLE_PIECE'
}

export const PipelineIconColorsList = Object.values(PipelineIconColorEnums)

export const PipelineIconEnumsList = Object.values(PipelineIconEnums)

export const PipelineIconsColors = {
   [PipelineIconColorEnums.Green]: {
      backgroundColor: '#4CA30D'
   },
   [PipelineIconColorEnums.Orange]: {
      backgroundColor: '#DC6803'
   },
   [PipelineIconColorEnums.Fuchsia]: {
      backgroundColor: '#BA24D5'
   },
   [PipelineIconColorEnums.Teal]: {
      backgroundColor: '#088AB2'
   },
   [PipelineIconColorEnums.Violet]: {
      backgroundColor: '#6938EF'
   },
   [PipelineIconColorEnums.BlueLight]: {
      backgroundColor: '#1570EF'
   }
}
